/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_push.js                                                                  */
/**********************************************************************************************************************/

HafasWebapp.prototype.Controller.Push = {
  currentSubscription: null,
  menuSelectBoxes: [],
  serviceWorker: null, // saves the service worker instance
  focusSelector: null, // for restoring focus after some action is performed
  init: function () {
  },
  index: function () {
    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("Push", "index", {});

    Hafas.Modules.Loader.loadTemplateFiles(['push.index.html'], Hafas.bind(function () {
      Hafas.bind(this.Controller.Push.renderIndex, this)();
    }, this));
  },
  renderIndex: function () {
    var me = this;
    var model = {
      hideSaveBtnIfLoggedIn: true, // Hide delete button at first, otherwise they may be shown during channel confirmation request
      type: 'new', // Hide delete button at first, otherwise they may be shown during channel confirmation request
      tripAlarmsHeading: Hafas.Modules.i18n.get('Push.index.t_N_TripAlarms'),
      showPauseAll: false
    };
    Hafas("#" + me.formContainer).innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplIndex", model);

    var alarmUserData = this.Controller.Push.getAlarmUserData();
    var alarmUser = this.Controller.Push.getCurrentAlarmCenterUser();
    if (alarmUserData !== null && alarmUser !== null) {
      if (alarmUserData["EMAIL"] && alarmUserData["EMAIL"] !== "" ) {
        // We have an email in localStorage, so we can assume the user is logged in
        Hafas.ps.pub('/push/setLoginState', [true]);
      }
    }

    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    Hafas.bind(this.Controller.Push.renderSubscriptionOverview, this)();
    Hafas.Util.gui.restoreFocus(focusSelector);

    Hafas.ps.pub('/GUI/form/show', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/app/events/resize');
    Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

  },
  sendLoginLinkPopup: function(){
    var alarmUserData = this.Controller.Push.getAlarmUserData();
    var email = "";
    if (Hafas.Config.Push.channels["email"].address) {
      email = Hafas.Config.Push.channels["email"].address;
    } else if (alarmUserData !== null) {
      email = alarmUserData["EMAIL"];
    }

    Hafas.ps.pub('/push/showInfoPopup', [{
      title: Hafas.Modules.i18n.get('Push.index.t_N_sendLoginLinkAgain'),
      content: Hafas.Modules.i18n.get('Push.index.t_N_sendLoginLinkAgainExplanation', {email: email}),
      type: 'confirm',
      onclickConfirm: "Hafas.ps.pub('/push/resendAccountInfo', [{'mailRcvr': '" + email + "', 'opts': {'type':'retrieveUserData'} }]);",
      confirmTitle:  Hafas.Modules.i18n.get('Push.index.t_N_sendLoginLink'),
      labelLong: Hafas.Modules.i18n.get('Push.index.t_L_Channel_email')
    }]);
  },
  getCurrentAlarmCenterUser: function () {
    var storage = Hafas.Core.newType("hafasStorage");
    var alarmCenterUser = storage.get('alarmUser_' + Hafas.Config.Storage.id);
    if (alarmCenterUser == null) {
      return null;
    } else {
      var user = JSON.parse(alarmCenterUser);
      if (typeof user.userId == 'undefined') {
        return null;
      } else {
        return user;
      }
    }
  },
  deleteUser: function(params,callback){
    Hafas.Modules.Pushservice.deleteUser(params,callback);
  },
  deleteUserDialog: function(){
    Hafas.ps.pub('/push/showInfoPopup', [{
      title: Hafas.Modules.i18n.get('Push.index.t_N_DeleteAlarmsAndData'),
      content: Hafas.Modules.i18n.get('Push.index.t_N_deleteAccountConfirmation'),
      type: 'confirm',
      confirmTitle: Hafas.Modules.i18n.get('Push.index.t_N_deleteAccountYes'),
      onCancel: function(){

      },
      onclickConfirm: "Hafas.ps.pub('/push/deleteUserConfirmation');"
    }]);
  },
  deleteUserConfirmation: function(){
    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    if(alarmCenterUser != null){
       this.Controller.Push.deleteAllSubscriptions(alarmCenterUser.userId,Hafas.bind(function() {
           this.Controller.Push.deleteUser(alarmCenterUser, Hafas.bind(function () {
             this.Controller.Push.removePushUserData();
             Hafas.bind(this.Controller.Push.closeInfoPopup,this)();
             Hafas.ps.pub('/push/showInfoPopup', [{
               title: Hafas.Modules.i18n.get('Push.index.t_N_deleteAccountDeletedTitle'),
               content: Hafas.Modules.i18n.get('Push.index.t_N_deleteAccountSuccess'),
               type: 'OK',
               confirmTitle: Hafas.Modules.i18n.get('common.label.t_N_OK')
             }]);
             if(this.appContext === "TP") {
               Hafas.bind(this.Controller.GUI.Push.showOptions, this)({ // In showOptions we need connectionType and currentIdx as used in /GUI/openPush
                 connectionType: this.Controller.TP.selectedConnection.connectionType,
                 arrayIdx: this.Controller.TP.selectedConnection.currentIdx
               });
             } else if (this.appContext === "Push") {
               Hafas.bind(this.Controller.Push.renderSubscriptionOverview, this)();
             }
           }, this), function () {

           });
       },this));
    }else{
      Hafas.bind(this.Controller.Push.closeInfoPopup,this)();
      Hafas.ps.pub('/push/showInfoPopup', [{
        title: Hafas.Modules.i18n.get('Push.error.t_N_NO_SUCH_USER_Title'),
        content: Hafas.Modules.i18n.get('Push.error.t_N_NO_SUCH_USER'),
        type: 'OK',
        confirmTitle: Hafas.Modules.i18n.get('common.label.t_N_OK')
      }]);
    }
  },
  deleteAllSubscriptions: function(userId,callback){
    Hafas.Modules.Pushservice.listSubscriptions({userId: userId}, Hafas.bind(function(subscriptionResults){
      if(subscriptionResults.svcResL.length > 0 && (subscriptionResults.svcResL[0].err === undefined || subscriptionResults.svcResL[0].err === "OK")){
         var subscriptionIdsToDelete = [];
         var result = subscriptionResults.svcResL[0].res;
         var conSubscrL = result.conSubscrL;
         if(typeof conSubscrL != 'undefined') {
           for (var c = 0; c < conSubscrL.length; c++) {
             subscriptionIdsToDelete.push(conSubscrL[c].subscrId);
           }
           Hafas.Modules.Pushservice.deleteSubscriptionList({
             userId: userId,
             subscriptionIds: subscriptionIdsToDelete
           },
          Hafas.bind(function () {
            if (typeof callback == 'function') {
              callback();
            }
          }, this));
         }else{
           callback();
         }
      }
    },this));
  },
  // Wechselt die User Id für das Alarm center
  revitalizeUserId: function(params,callback){
      // Check if cookie type is not active
      if(!Hafas.Util.isCookieTypeActive('functional')) {
        Hafas.ps.pub('/GUI/common/showCookieSettingsHint', [['functional']]);
        return;
      }
      var storage = Hafas.Core.newType("hafasStorage");
      if(typeof params.userId != 'undefined') {
        Hafas.Modules.Pushservice.getUserDetails({
          userId: params.userId
        }, function(hciResponse) {
          var userResult = hciResponse.svcResL[0].res.result;
          var hasConfirmedEmailChannel = false;
          var channels = hciResponse.svcResL[0].res?.details?.availableChannels || [];
          for (var i = 0; i < channels.length; i++) {
            if (channels[i].type === "EMAIL" && channels[i].confirmed === true) {
              hasConfirmedEmailChannel = true;
            }
          }
          if (hasConfirmedEmailChannel === false) {
            // If the channel is not confirmed yet, we don't want any (false) error popup
            params.hideErrorPopup = true;
          }
          if(userResult.resultCode === "OK" && hasConfirmedEmailChannel === true) {
            var alarmCenterUser = {userId: params.userId};
            // Alarm Center User Id in LocalStorage überführen
            storage.set('alarmUser_' + Hafas.Config.Storage.id, JSON.stringify(alarmCenterUser));

            // Aktuelle Kanäle in LocalStorage überführen
            var userDetails = hciResponse.svcResL[0].res.details;
            var channelData = {};
            if(typeof userDetails.availableChannels != 'undefined') {
              for (var a = 0; a < userDetails.availableChannels.length; a++) {
                var tmpChannel = userDetails.availableChannels[a];
                if (tmpChannel.type === "WEBPUSH") {
                  // For webpush we have to check the endpoint first in order to not set the wrong browser address
                  var _address;
                  try {
                    // We have to use try/catch as we cannot detect if the address is a direct token or a JSON string while iterating the channels
                    // VAPID
                    _address = JSON.parse(tmpChannel.address);
                  } catch (e) {
                    // APNS tokens are used directly
                    _address = {endpoint: tmpChannel.address};
                  }

                  var currentEndpoint = Hafas.Config.Push.clientEndpoint;
                  if (currentEndpoint !== undefined && currentEndpoint === _address.endpoint) {
                    // Endpoint matches, we can save the channel
                    channelData[tmpChannel.type] = tmpChannel.address;
                    if (Hafas.Config.Push && Hafas.Config.Push.channels[tmpChannel.type.toLowerCase()] ) {
                      // If we have found a channel address, save it into the channel config
                      Hafas.Config.Push.channels[tmpChannel.type.toLowerCase()].address = tmpChannel.address;
                    }
                  }
                } else {
                  channelData[tmpChannel.type] = tmpChannel.address;
                  if (Hafas.Config.Push && Hafas.Config.Push.channels[tmpChannel.type.toLowerCase()] ) {
                    // If we have found a channel address, save it into the channel config
                    Hafas.Config.Push.channels[tmpChannel.type.toLowerCase()].address = tmpChannel.address;
                  }
                }
              }
              storage.set('alarmUserData_' + Hafas.Config.Storage.id, JSON.stringify(channelData));
            }


            // Aktuelle Subscriptions abholen und in LocalStorage überführen
            Hafas.Modules.Pushservice.listSubscriptions({userId: params.userId}, Hafas.bind(function (subscriptionResults) {
                if(typeof subscriptionResults.svcResL != 'undefined' && subscriptionResults.svcResL.length > 0){
                  var tmpSubResult = subscriptionResults.svcResL[0].res;
                  var subscriptionData = {}
                  if(typeof tmpSubResult.conSubscrL != 'undefined') {
                    for (var t = 0; t < tmpSubResult.conSubscrL.length; t++) {
                       var tmpSubscr = tmpSubResult.conSubscrL[t];
                       var ctxRecon = tmpSubscr.ctxRecon;
                       if(tmpSubscr.ctxReconCksumSave){
                         subscriptionData[tmpSubscr.ctxReconCksumSave] = tmpSubscr.subscrId;
                       }
                       else {
                         subscriptionData[ctxRecon] = tmpSubscr.subscrId;
                       }
                    }
                  }
                  storage.set('alarmSubscriptions_' + Hafas.Config.Storage.id, JSON.stringify(subscriptionData));
                }
                // Verarbeitung der User Account Daten abgeschlossen, Callback feuern wenn verfügbar
                if(typeof callback != 'undefined'){
                  callback();
                }
            },this));
            if(typeof params.hidePopup == 'undefined' || params.hidePopup == false) {
              Hafas.ps.pub('/push/showInfoPopup', [{
                title: Hafas.Modules.i18n.get('Push.index.t_N_RegistrationSuccessful'),
                content: Hafas.Modules.i18n.get('Push.index.t_N_RegistrationSuccessfulText'),
                type: 'OK'
              }]);
            }
          }else{
            // User ist nicht vorhanden, etwaige LocalStorage Einträge löschen
            storage.remove('alarmUser_' + Hafas.Config.Storage.id);
            storage.remove('alarmUserData_' + Hafas.Config.Storage.id);
            storage.remove('alarmSubscriptions_' + Hafas.Config.Storage.id);

            // Set logout state
            Hafas.ps.pub('/push/setLoginState', [false]);

            // Verarbeitung der User Account Daten abgeschlossen, Callback feuern wenn verfügbar
            if(typeof callback != 'undefined'){
              callback();
            }
            if(typeof params.hideErrorPopup == 'undefined' || params.hideErrorPopup == false) {
              Hafas.ps.pub('/push/showInfoPopup', [{
                title: Hafas.Modules.i18n.get('Push.error.t_N_' + userResult.externalError + '_Title'),
                content: Hafas.Modules.i18n.get('Push.error.t_N_' + userResult.externalError),
                type: 'OK'
              }]);
            }
          }
        });
      }else{
         console.warn("User can't be switched, UserId is missing.");
      }
  },
  setupAlarmType: function(data){
      // Alarm ist bereits aktiv und wird gelöscht
      if(data.active){
        if(typeof data.subscrId != 'undefined' && data.subscrId != null) {
          Hafas.ps.pub('/push/delete', [{ ctxRecon: data.ctxRecon, subscrId: data.subscrId, ctx:'overview'}]);
        }
      }else {
        // Alarm muss erst neu angelegt werden
        if (Notification.permission === "granted") {
          Hafas.bind(this.Controller.Push.setupAlarmSubscription, this)(data);
        } else {
          Notification.requestPermission(Hafas.bind(function (permission) {
            if (permission === "granted") {
              Hafas.bind(this.Controller.Push.setupAlarmSubscription, this)(data);
            }
          }, this));
        }
      }
  },
  setupAlarmSubscription: function (data) {
    var alarmType = data.type;
    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    if(alarmCenterUser == null){
      Hafas.bind(this.Controller.Push.createNewAlarmCenterUser,this)(
          Hafas.bind(function(data){
            var user = this.Controller.Push.storeAlarmCenterUser(data);

            // InfoPopup anzeigen
            Hafas.ps.pub('/push/showInfoPopup', [{
              title: Hafas.Modules.i18n.get('Push.index.t_N_LoginLinkSent'),
              content: Hafas.Modules.i18n.get('Push.index.t_N_LoginLinkSentExplanation'),
              type: 'OK'
            }]);

            Hafas.Modules.Pushservice.getUserDetails({
              userId: user.userId
            }, Hafas.bind(this.Controller.Push.setupAlarm,this), function(){
              alert("User details konnten nicht abgerufen werden.");
            });
          },this),
          function(){ }
      );
    } else {
      Hafas.Modules.Pushservice.getUserDetails({
        userId: alarmCenterUser.userId
      }, Hafas.bind(this.Controller.Push.setupAlarm, this), function () {
        alert("User details konnten nicht abgerufen werden.");
      });
    }
  },
  /**
   * Zeigt Verbindungsdetails auf Basis einer subscrId,userId
   * @method showConnDetails
   * @param {Object} data
   * @param {String} data.userId
   * @param {Number} data.subscrId
   */
  showConnDetails: function(data){
    var userId = data.userId;
    var subscrId = data.subscrId;
    Hafas.Modules.Pushservice.getSubscriptionDetails({
      subscriptionIds: [subscrId],
      userId: userId
    }, Hafas.bind(function (subscriptionDetails, idx) {
        if(subscriptionDetails.status.error == false && subscriptionDetails.svcResL.length > 0) {
          var subscriptionResult = subscriptionDetails.svcResL[0].res;
          var subscriptionResultDetails = subscriptionResult.details;
          var subscriptionResultCode = subscriptionResult.result.resultCode;
          if(subscriptionResultCode == "OK" && typeof subscriptionResultDetails.conSubscr !== 'undefined'){
            Hafas.bind(this.Controller.TP.searchReconstruction,this)(subscriptionResultDetails.conSubscr.ctxRecon, "ctxRecon");
          }else{
            Hafas.ps.pub('/GUI/smallAlert/show', [Hafas.Modules.i18n.get('Push.error.t_N_ALARM_NOT_FOUND')]);
          }
        }
    },this));
  },
  getChannels: function (data, type) {
    var channels = [];
    var availableChannels = data.svcResL[0].res.availableChannels;
    if (typeof availableChannels != 'undefined') {
      for (var a = 0; a < availableChannels.length; a++) {
        if (availableChannels[a].type === type) {
          channels.push(availableChannels[a]);
        }
      }
    }
    return channels;
  },
  setupAlarm: function (data, options, callback) {
    options = options || {};

    if (data.status.error === false && data.svcResL.length > 0) {
      if (data.svcResL[0].err === undefined || data.svcResL[0].err === 'OK') {
        var currConn = this.Controller.Push.currentConnection;
        var currSub = this.Controller.Push.currentSubscription;
        var userId = data.svcResL[0].res.userId || data.svcResL[0].res.details.userId;
        if (currConn !== undefined) {
          var connectionData = {
            depLocation: currConn.dep.locResolved.name,
            arrLocation: currConn.arr.locResolved.name,
            date: currConn.date,
            depTime: currConn.dep.dTimeS,
            arrTime: currConn.arr.aTimeS
          };
        }

        // Preparation of the channels to be stored
        var userDetailsResult = data.svcResL[0].res;
        var channelsToUse = [];
        var availableChannels = [];
        var channelTypeDictionary = {}; // Save the type for channelId's, as we can't put them directly inside the channel
        var currSubCh = this.Controller.Push.currentSubscription.channels;
        var currSubSettings = this.Controller.Push.currentSubscription.settings;
        if (userDetailsResult.availableChannels !== undefined || userDetailsResult.details !== undefined) {
          availableChannels = userDetailsResult.availableChannels || userDetailsResult.details.availableChannels;
        }

        // In the view, channel has to be used and checked
        for (var c in currSubCh) {
          if (currSubCh[c].use === true && currSubCh[c].checked === true) {
            var subscriptionCh = {
              type: c.toUpperCase(),
              address: currSubCh[c].address,
              active: currSubCh[c].checked, // Make it active only when checked, however we do need a email channel even if only webpush is used
              channelId: ''
            };
            // Check if there is a channel existing for this address and type, then use its existing channelId
            if (typeof availableChannels != 'undefined') {
              for (var ac = 0; ac < availableChannels.length; ac++) {
                if (availableChannels[ac].type === c.toUpperCase() && availableChannels[ac].address === currSubCh[c].address) {
                  // We cannot just add the channelId here, we must overwrite the whole object to use the existing channel and only use its ID
                  // Otherwise we get a BAD_USER_INPUT if we want to change the active status here
                  subscriptionCh = {channelId: availableChannels[ac].channelId};
                  // Save the type for the ID - even it's part of the channelId, we are not sure if it always is, so don't parse it out of the ID
                  channelTypeDictionary[availableChannels[ac].channelId] = c;
                }
              }
            }
            channelsToUse.push(subscriptionCh);
          }
        }

        // Iterate and add existing subscribed channels for this subscription
        var otherActiveChannels = Hafas.bind(this.Controller.Push.getOtherActiveChannels, this)();
        channelsToUse = channelsToUse.concat(otherActiveChannels);

        if (channelsToUse.length === 0) {
          var pushErrorWrapperChannels = Hafas('#HFS_PushErrorWrapperChannels', false);
          if (pushErrorWrapperChannels) {
            var errorMsgsChannels = [];
            errorMsgsChannels.push({
              type: 'NO_CHANNELS_SELECTED',
              label: Hafas.Modules.i18n.get('Push.index.t_N_SelectAChannel')
            });
            // Error highlighting on checkboxes
            var channelCheckboxes = Hafas('.lyr_pushChannelCheckboxLabel', true);
            for (var i = 0; i < channelCheckboxes.length; i++) {
              Hafas.ps.pub('/GUI/common/highlightingInput',[{type: 'element', element: channelCheckboxes[i], className: 'js_highLightingErrorBorder', keepClass: true }]);
            }
            // Error message
            pushErrorWrapperChannels.innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgsChannels});
          }
        } else {
        // If there is at least one channel, the subscription can be created
          var subscriptionData = {
            type: 'conSubscr',
            userId: userId,
            channels: channelsToUse,
            channelTypeDict: channelTypeDictionary,
            hysteresis: {
              notificationStart: currSubSettings.notificationStart,
              minDeviationFollowing: currSubSettings.minDeviationFollowing,
              minDeviationInterval: currSubSettings.minDeviationInterval
            }
          };

          if (typeof connectionData != 'undefined') {
            subscriptionData.data = JSON.stringify(connectionData);
          }
          if (typeof currConn != 'undefined') {
            subscriptionData.ctxRecon = currConn.ctxRecon || currConn.recon.ctx;
            subscriptionData.cksumSave = currConn.cksumSave;
            subscriptionData.serviceDays = {
              beginDate: currConn.date,
              endDate: currConn.date
            }
          }

          if (typeof currSub.serviceDays != 'undefined') {
            if (typeof subscriptionData.serviceDays == 'undefined') {
              subscriptionData.serviceDays = {};
            }
            for (var s in currSub.serviceDays) {
              subscriptionData.serviceDays[s] = currSub.serviceDays[s];
            }
            // With weekday selection, monitor until the end of the timetable period
            if (typeof subscriptionData.serviceDays.selectedWeekdays != 'undefined' && subscriptionData.serviceDays.selectedWeekdays != null && subscriptionData.serviceDays.selectedWeekdays.indexOf("1") > -1) {
              var hfsPeriodEnd = Hafas.Core.newType("hafasTime", {jsDate: Hafas.Config.periodEnd});
              subscriptionData.serviceDays.endDate = hfsPeriodEnd.format("YYYYMMDD");
            } else {
              if(currConn !== undefined) {
                subscriptionData.serviceDays.endDate = currConn.date;
              }
            }
          }

          var pushServiceFunc = "addSubscription";

          if (options.update === true) {
            subscriptionData.subscrId = this.Controller.Push.currentSubscription.subscrId;
            if (this.Controller.Push.currentSubscription.conSubscr !== undefined) {
              subscriptionData.ctxRecon = this.Controller.Push.currentSubscription.conSubscr.ctxRecon;
            }
            pushServiceFunc = "updateSubscription";
          }

          // addSubscription or updateSubscription call
          Hafas.Modules.Pushservice[pushServiceFunc](subscriptionData, Hafas.bind(function (data, subscrData) {
            var resultCode = data.svcResL[0].res.result.resultCode;
            if (resultCode !== 'ERROR') {
              // No error in HCI call
              var subscrId = data.svcResL[0].res.subscrId;
              if (Hafas.Config.Push.userIsLoggedIn === true) {
                Hafas.bind(this.Controller.Push.storeSubscription, this)(subscrData.cksumSave, subscrData.ctxRecon, subscrId);
              }

              // Remove step from history
              Hafas.Modules.History.removeCurrentStep("createAlarm");

              // Alarm was created successful => jump back to connection details
              if (this.appContext === 'TP') {
                Hafas.bind(this.Controller.TP.renderConnectionDetails, this)(this.Controller.TP.selectedConnection, {
                  connectionType: this.Controller.TP.activeSelection.connType,
                  arrayIdx: this.Controller.TP.activeSelection.arrayIdx
                });
              } else {
                Hafas.bind(this.Controller.Push.renderIndex, this)();
                Hafas.ps.pub('/GUI/form/show', [{}]);
                Hafas.ps.pub('/GUI/results/overview/hide', [{}])
                Hafas.ps.pub('/app/events/resize');
              }

              if (Hafas.Config.Push.userIsLoggedIn === true) {

                var saveAlarmUpdateMsg = Hafas.Modules.i18n.get('Push.result.t_N_Success');
                if (options.update === true) {
                  saveAlarmUpdateMsg = Hafas.Modules.i18n.get('Push.result.t_N_SuccessUpdate');
                }
                Hafas.ps.pub('/GUI/smallAlert/show', [saveAlarmUpdateMsg]);

                var storage = Hafas.Core.newType("hafasStorage");
                var alarmUserData = storage.get('alarmUserData_' + Hafas.Config.Storage.id);
                if (alarmUserData == null) {
                  var newAlarmUserData = {};
                  for (var j = 0; j < subscrData.channels.length; j++) {
                    var channel = subscrData.channels[j];
                    if (channel.type === 'EMAIL') {
                      newAlarmUserData[channel.type] = channel.address;
                    }
                  }
                  storage.set('alarmUserData_' + Hafas.Config.Storage.id, JSON.stringify(newAlarmUserData));
                }
              }
              if (typeof callback == 'function') {
                callback();
              }
            } else {
              // Error in HCI call
              var saveBtn = Hafas('#HFS_PUSH_SAVE_BTN_' + Hafas.getWebAppContext(), false);
              if (saveBtn) {
                saveBtn.disabled = false;
              }
              if (data.svcResL[0].res.result.externalError === "DUPLICATE_ADDRESS") {
                var email = '';
                for (var k = 0; k < subscrData.channels.length; k++) {
                  var channel = subscrData.channels[k];
                  if (channel.type === 'EMAIL') {
                    email = channel.address;
                  }
                }
                Hafas.ps.pub('/push/showInfoPopup', [{
                  title: Hafas.Modules.i18n.get('Push.error.t_N_Title_UserAlreadyRegistered'),
                  content: Hafas.Modules.i18n.get('Push.error.t_N_Content_UserAlreadyRegistered'),
                  type: 'confirm',
                  subscrData: subscrData,
                  onclickConfirm: "Hafas.ps.pub('/push/resendAccountInfo',[{'mailRcvr': '" + email + "'}]);return false;",
                  onCancel: function () {

                  },
                  onConfirm: function () {

                  }
                }]);
              } else {
                Hafas.ps.pub('/GUI/smallAlert/show', [Hafas.Modules.i18n.get('Push.result.t_N_Failure')]);
              }
            }

          }, this, subscriptionData));
        }
      }
    }
  },
  resendAccountInfo: function(params){
      var content = Hafas.Modules.i18n.get('Push.index.t_N_LoginLinkSentExplanation');
      Hafas.Modules.Pushservice.resendAccountInfo(params, Hafas.bind(function(){
        Hafas.bind(this.Controller.Push.closeInfoPopup,this)();
        Hafas.ps.pub('/push/showInfoPopup', [{
          title: Hafas.Modules.i18n.get('Push.index.t_N_LoginLinkSent'),
          content: content,
          type: 'OK'
        }]);
      },this),
      function(){
        Hafas('#HFS_PushPopupContent',false).innerHTML = Hafas.Modules.i18n.get('Push.error.t_N_MailSentFailed');
      });
  },
  confirmChannel: function(params){
    // Kanal bestätigen
    Hafas.Modules.Pushservice.confirmChannel(params, function(data){
    },
    function(){
        console.warn("An error has occurred during channel confirmation");
    });
  },
  /* Legt einen Rekonstruktionkontext ab, um gespeicherte Abos wiedererkennen zu können */
  storeSubscription: function (cksumSave, ctxRecon, subscrId) {
    var storage = Hafas.Core.newType("hafasStorage");
    var pushSubscrStorageId = 'alarmSubscriptions_' + Hafas.Config.Storage.id;
    var subscriptions = storage.get(pushSubscrStorageId);
    var newSubscriptionObject = {};
    if (subscriptions != null) {
      newSubscriptionObject = JSON.parse(subscriptions);
    }
    //var b64encodedCtxRecon = Hafas.Util.b64EncodeUnicode(ctxRecon);
    if(cksumSave){
      newSubscriptionObject[cksumSave] = subscrId;
    }
    else {
      newSubscriptionObject[ctxRecon] = subscrId;
    }
    storage.set(pushSubscrStorageId, JSON.stringify(newSubscriptionObject));
  },
  deleteSubscriptionStorage: function (cksumSave, ctxRecon) {
    var storage = Hafas.Core.newType("hafasStorage");
    var pushSubscrStorageId = 'alarmSubscriptions_' + Hafas.Config.Storage.id;
    var subscriptions = storage.get(pushSubscrStorageId);
    var newSubscriptionObject = {};
    if (subscriptions != null) {
      newSubscriptionObject = JSON.parse(subscriptions);
      if (typeof newSubscriptionObject[cksumSave] != 'undefined') {
        delete newSubscriptionObject[cksumSave];
        storage.set(pushSubscrStorageId, JSON.stringify(newSubscriptionObject));
      }
      else if (typeof newSubscriptionObject[ctxRecon] != 'undefined') {
        delete newSubscriptionObject[ctxRecon];
        storage.set(pushSubscrStorageId, JSON.stringify(newSubscriptionObject));
      }
    }
  },
  storeAlarmCenterUser: function (data) {
    var storage = Hafas.Core.newType("hafasStorage");
    if (data.status.error === false && data.svcResL.length > 0) {
      if (data.svcResL[0].err === undefined || data.svcResL[0].err === 'OK') {
        var result = data.svcResL[0].res.result;
        var userId = data.svcResL[0].res.userId;
      }
    }
    var alarmCenterUser = {userId: userId};
    storage.set('alarmUser_' + Hafas.Config.Storage.id, JSON.stringify(alarmCenterUser));
    return alarmCenterUser;
  },
  /**
   * Removes alarm storage entries and also the addresses from channel configs
   */
  removePushUserData: function() {
    // Delete entries from storage
    var storage = Hafas.Core.newType("hafasStorage");
    storage.remove('alarmUser_' + Hafas.Config.Storage.id);
    storage.remove('alarmUserData_' + Hafas.Config.Storage.id);
    storage.remove('alarmSubscriptions_' + Hafas.Config.Storage.id);

    if (Hafas.Config.Push && Hafas.Config.Push.channels) {
      for (var channelId in Hafas.Config.Push.channels) {
        var channel = Hafas.Config.Push.channels[channelId];
        delete channel.address; // Address might be stored in the config object
      }
    }

    // Set logout state
    Hafas.ps.pub('/push/setLoginState', [false]);
  },
  /**
   * Creates a user with an email channel, if succeeded the user gets a confirmation email. If DUPLICATE_ADDRESS error occurs,
   * the user will get a login link
   */
  createOrLoginUser: function() {
    // Try to create a new user with the given email; If mail is found already, a DUPLICATE_ADDRESS is expected. Then sent login link to that user
    var pushErrorWrapperMail = Hafas('#HFS_PushErrorWrapperMail', false);
    var saveBtn = Hafas('#HFS_PUSH_SAVE_BTN_' + Hafas.getWebAppContext(), false);
    var errorMsgsMail = [];
    var availableChannels = [];
    var inputElement = Hafas("#HFS_PUSHCHANNELINPUT_EMAIL_" + Hafas.getWebAppContext()); // OK to not append the subscrId here, as createOrLoginUser is only called in alarm center index view login, when there is no subscription

    // Check channels of the currentSubscription, it is expected that email channel has a address
    if (this.Controller.Push.currentSubscription) {
      var currSub = this.Controller.Push.currentSubscription;
      for (var channelId in currSub.channels) {
        if (currSub.channels.hasOwnProperty(channelId) && currSub.channels[channelId].use === true && currSub.channels[channelId].default === true) {
          if (!currSub.channels[channelId].address) {
            // If mail validation on input blur fails, it will remove the address from the channel
            errorMsgsMail.push({
              type: 'NO_CHANNEL_ADDRESS',
              label: Hafas.Modules.i18n.get('Push.index.t_N_FillInfo_' + channelId)
            });
            // Error highlight
            if (inputElement !== null) {
              Hafas.ps.pub('/GUI/common/highlightingInput',[{type: 'element', element: inputElement, className: 'js_highLightingErrorBorder', keepClass: true }]);
            }
          }

          var subscriptionCh = {
            type: channelId.toUpperCase(),
            address: currSub.channels[channelId].address,
            active: currSub.channels[channelId].default, // Make it active only when checked, however we do need a email channel even if only webpush is used
            channelId: ''
          };
          // Push channel into array as initial channels for a new user
          availableChannels.push(subscriptionCh);
        }
      }
    }

    if (errorMsgsMail.length > 0) {
      // Errors with mail

      // Deactivate save button
      if (saveBtn) {
        saveBtn.disabled = true;
      }
      // Handle errors for mail area
      if (pushErrorWrapperMail !== null) {
        if (errorMsgsMail.length > 0) {
          pushErrorWrapperMail.innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgsMail});
        } else {
          pushErrorWrapperMail.innerHTML = "";
        }
      }
      return;
    }

    if (pushErrorWrapperMail !== null && errorMsgsMail.length === 0) {
      pushErrorWrapperMail.innerHTML = "";
      Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type:'element', element: inputElement, className: 'js_highLightingErrorBorder'} ]);
    }

    // There is no alarm user in localStorage => create an user
    Hafas.bind(this.Controller.Push.createNewAlarmCenterUser, this)(
      Hafas.bind(function (data) {
        if (data.errorStatus !== 'ERROR' && data.svcResL?.length > 0) {
          var resultCode = data.svcResL[0].res.result.resultCode;
          if (resultCode !== 'ERROR') {
            // Confirmation mail send
            Hafas.ps.pub('/push/showInfoPopup', [{
              title: Hafas.Modules.i18n.get('Push.index.t_N_LoginLinkSent'),
              content: Hafas.Modules.i18n.get('Push.index.t_N_LoginLinkSentExplanation'),
              type: 'OK'
            }]);
          } else if (data.svcResL[0].res?.result?.externalError === "DUPLICATE_ADDRESS"){
            // DUPLICATE_ADDRESS - user already exists. Send login email
            var email = '';
            for(var i = 0; i < availableChannels.length;i++){
              var channel = availableChannels[i];
              if (channel.type === 'EMAIL'){
                email = channel.address;
              }
            }
            if (email !== '') {
              Hafas.ps.pub('/push/resendAccountInfo',[{'mailRcvr': email}]);
            }
          } else {
            Hafas.ps.pub('/GUI/smallAlert/show', [Hafas.Modules.i18n.get('Push.result.t_N_Failure')]);
          }
        } else {
          errorMsgsMail.push({
            type: 'SERVER_ERROR',
            label: Hafas.Modules.i18n.get('Push.error.t_N_ServerException')
          });
          pushErrorWrapperMail.innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgsMail});

          // Make save button active again
          if (saveBtn) {
            saveBtn.disabled = false;
          }
        }
      }, this),
      function (errCreateUserRequestErr) {
        errorMsgsMail.push({
          type: 'ERROR',
          label: Hafas.Modules.i18n.get('Push.result.t_N_Failure')
        });
        pushErrorWrapperMail.innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgsMail});
      },
      availableChannels
    );
  },
  /**
   * Creates a new alarm center user
   * @param callback
   * @param errorCallback
   * @param availableChannels
   */
  createNewAlarmCenterUser: function (callback, errorCallback, availableChannels) {
    availableChannels = availableChannels || [];
    Hafas.Modules.Pushservice.createUser({
      availableChannels: availableChannels,
      language: Hafas.Config.currLangObj.iso
    }, callback, errorCallback);
  },
  /**
   * Sets the login state of the user in the Push config
   * @param {boolean} isUserLoggedIn Defines whether the user is logged in or not
   * @param {boolean} [preventTabNavHeadingRendering] Default: false. Prevent calling /GUI/tabNavigationHeading/render which would render an actionbar
   */
  setLoginState: function (isUserLoggedIn, preventTabNavHeadingRendering) {
    if (Hafas.Config.Push) {
      Hafas.Config.Push.userIsLoggedIn = isUserLoggedIn || false;
      // After we set the login state, we should rerender the Push actionbar to show or hide the link button
      if (Hafas.getWebAppContext() === "Push" && preventTabNavHeadingRendering !== true) {
        Hafas.ps.pub('/GUI/tabNavigationHeading/render', []);
      }
    }
  },
  changeAlarmCenterTab: function (data) {
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    var view = 'subscriptions';
    if (data.activeIndex == 1) {
      view = 'history';
    }
    if (view == 'subscriptions') {
      Hafas.bind(this.Controller.Push.renderSubscriptionOverview, this)(data);
    } else {
      Hafas.bind(this.Controller.Push.renderHistoryOverview, this)(data);
    }
    Hafas.Util.gui.restoreFocus(focusSelector);
    Hafas.ps.pub('/app/events/resize');
  },
  renderSubscriptionOverview: function () {
    var self = this;

    var model = {
      activeAlarmTypes: [],
      type: 'new', // Hides the delete btn in Push_AtomTplChannelMailActivation
      hideSaveBtnIfLoggedIn: true, // Hides the saveBtn if the user is logged in, because then there is nothing to save in the alarm center
      tripAlarmsHeading: Hafas.Modules.i18n.get('Push.index.t_N_TripAlarms')
    };

    Hafas.bind(this.Controller.Push.createDefaultSubscription, this)(); // Needed for validateChannelInput

    var focus = this.Controller.Push.focusSelector;
    this.Controller.Push.focusSelector = null; // avoid unintentionally restoring focus later on

    function reRenderAlarmCenter(model) {
      // Check for non paused alarms to show pause button
      var hasActiveAlarms = false;
      if (model.activeAlarmTypes !== undefined) {
        for (var i = 0; i < model.activeAlarmTypes.length; i++) {
          var activeAlarmType = model.activeAlarmTypes[i];
          if (activeAlarmType.subscriptionsDetails) {
            for (var j = 0; j < activeAlarmType.subscriptionsDetails.length; j++) {
              var subscr = activeAlarmType.subscriptionsDetails[j];
              if (subscr.details && subscr.details.conSubscr && subscr.details.conSubscr.serviceDays !== undefined && subscr.details.conSubscr.serviceDays.pauseBegin === undefined) {
                hasActiveAlarms = true;
              }
            }
          }
        }
      }
      model.showPauseAll = hasActiveAlarms;

      var currentTarget = Hafas('#HFS_PUSH_SUBSCRIPTIONS', false);
      if (currentTarget !== null) {
        currentTarget.innerHTML = Hafas.Modules.Render.renderTemplate('Push_TplIndex_Subscriptions', model);

        var pushLoader = Hafas('#HFS_PUSH_LOADER', false);
        if (pushLoader !== null) {
          Hafas.Util.gui.setVisibility(pushLoader, false);
        }
      }

      var alarmCenterUser = self.Controller.Push.getCurrentAlarmCenterUser();
      if (alarmCenterUser != null) {
        Hafas.Modules.Pushservice.getUserDetails({
          userId: alarmCenterUser.userId
        }, Hafas.bind(function (userDetails) {
          var userResult = userDetails.svcResL[0].res;
          // prüfen, ob alarme pausieren
          if (typeof userResult != 'undefined' &&
             (typeof userResult.pauseBegin != 'undefined' || (typeof userResult.details != 'undefined' && typeof userResult.details.pauseBegin != 'undefined'))) {
            if (Hafas('#HFS_PushPauseAlarms', false)) {
              Hafas('#HFS_PushPauseAlarms', false).checked = true;
            }
          }
        }, this));
      }

      Hafas.ps.pub('/app/events/resize');

      if (focus && typeof focus === 'object') {
        var toggleButton = Hafas('button[aria-controls="alarmSubscription_' + focus.subscrId + '"]', false);
        if (toggleButton && typeof toggleButton.click === 'function') {
          toggleButton.click();
          Hafas.Util.gui.restoreFocus(focus.focusSelector);
        }
      } else {
        Hafas.Util.gui.focusTabOrMenuButton();
      }
    }

    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    if (Hafas.Config.Push.basicSingleTrip) {
      model.activeAlarmTypes.push({
        type: 'basicSingleTrip',
        hciType: 'conSubscrL',
        subscriptions: []
      });
    }
    if (alarmCenterUser != null) {
      Hafas.Modules.Pushservice.listSubscriptions({userId: alarmCenterUser.userId}, Hafas.bind(function (subscriptionResults) {
        if (subscriptionResults.svcResL[0].err === undefined || subscriptionResults.svcResL[0].err === "OK") {
          for (var s = 0; s < model.activeAlarmTypes.length; s++) {
            model.activeAlarmTypes[s].subscriptions = this.Controller.Push.getSubscriptionData(subscriptionResults, model.activeAlarmTypes[s].hciType);
            model.activeAlarmTypes[s].subscriptionsDetails = [];
            var subscriptionIds = [];
            for (var m = 0; m < model.activeAlarmTypes[s].subscriptions.length; m++) {
              subscriptionIds.push(model.activeAlarmTypes[s].subscriptions[m].subscrId);
            }
            // Details zu den Push Meldungen abrufen
            if (subscriptionIds.length > 0) {
              Hafas.Modules.Pushservice.getSubscriptionDetails({
                subscriptionIds: subscriptionIds,
                userId: alarmCenterUser.userId
              }, Hafas.bind(function (subscriptionDetails, idx) {
                for (var d = 0; d < subscriptionDetails.svcResL.length; d++) {
                  var currentResult = subscriptionDetails.svcResL[d];
                  model.activeAlarmTypes[idx].subscriptionsDetails.push(currentResult.res);
                }
                reRenderAlarmCenter(model);
              }, this, s))
            } else {
              reRenderAlarmCenter(model);
            }
          }
        } else {
          model.errorCode = subscriptionResults.svcResL[0].err;
          model.errorTxt = Hafas.Modules.i18n.get('Push.error.t_N_' + model.errorCode);
          reRenderAlarmCenter(model);
        }
      }, this));
    } else {
      reRenderAlarmCenter(model);
    }
  },
  prepareHistoryMessageList: function (subscriptionDetails) {
    var msgList = [];
    if (typeof subscriptionDetails.svcResL != 'undefined') {
      for (var d = 0; d < subscriptionDetails.svcResL.length; d++) {
        var currentResult = subscriptionDetails.svcResL[d].res;
        var eventHistory = currentResult.eventHistory || currentResult.details.eventHistory;
        // himEvents: This list contains details about all HIM messages that are referenced in rtEvents.
        // The actually pushed notification are listed in rtEvents. In case the notification is caused by a HIM message
        // the message will be referenced in rtEvents and details about the message can be found here. (lookup by id and timestamp)
        // Therefore we should only render messages from rtEvents
        // Only use messages in himEvents to get information about the HIM messages
        if (typeof eventHistory.rtEvents != 'undefined') {
          for (var r = 0; r < eventHistory.rtEvents.length; r++) {
            var tmpRtEvent = eventHistory.rtEvents[r];
            tmpRtEvent.hciTimestamp = Hafas.Util.date.ISODateToHCIDate(tmpRtEvent.received);
            var hciTimeObject = Hafas.Core.newType("hafasTime", {
              date: tmpRtEvent.hciTimestamp.hciDate,
              time: tmpRtEvent.hciTimestamp.hciTime
            });
            tmpRtEvent.jsTimestamp = hciTimeObject.getJsDate();
            msgList.push(tmpRtEvent);
          }
        }
      }
    }
    msgList.sort(function (a, b) {
      return b.jsTimestamp.getTime() - a.jsTimestamp.getTime();
    });
    return msgList;
  },
  renderHistoryOverview: function (data) {
    var renderTpl = 'Push_TplIndex_History';
    var model = {};
    var currentTarget = data.target;
    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    if (alarmCenterUser != null) {
      Hafas.Modules.Pushservice.listSubscriptions({userId: alarmCenterUser.userId}, Hafas.bind(function (subscriptionResults) {
        var subscriptions = this.Controller.Push.getSubscriptionData(subscriptionResults, 'conSubscrL');
        var subscriptionIds = [];
        for (var m = 0; m < subscriptions.length; m++) {
          subscriptionIds.push(subscriptions[m].subscrId);
        }
        Hafas.Modules.Pushservice.getSubscriptionDetails({
          subscriptionIds: subscriptionIds,
          userId: alarmCenterUser.userId
        }, Hafas.bind(function (subscriptionDetails, idx) {
          //model.msgList = msgList;
          model.msgList = this.Controller.Push.prepareHistoryMessageList(subscriptionDetails);
          currentTarget.innerHTML = Hafas.Modules.Render.renderTemplate(renderTpl, model);
          Hafas.ps.pub('/app/events/resize', []);
        }, this));

      }, this))
    } else {
      currentTarget.innerHTML = Hafas.Modules.Render.renderTemplate(renderTpl, model);
    }
  },
  getSubscriptionData: function (data, type) {
    var subscriptionData = [];
    if (data.svcResL.length > 0 && (data.svcResL[0].err === undefined || data.svcResL[0].err === "OK")) {
      var result = data.svcResL[0].res;
      if (typeof result[type] != 'undefined') {
        subscriptionData = result[type];
      }
    }
    return subscriptionData;
  },
  showMessages: function (data) {
    var viewCtx = 'Push';
    if (data.origin === 'TP') {
      viewCtx = 'TP';
    }
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    var model = {};
    if (alarmCenterUser != null) {
      Hafas.Modules.Pushservice.getSubscriptionDetails({
        subscriptionIds: [data.subscrId],
        userId: alarmCenterUser.userId
      }, Hafas.bind(function (subscriptionDetails, idx) {
        var result = subscriptionDetails.svcResL[0].res;
        model.subscrId = result.subscrId || result.details.subscrId;
        model.conSubscr = result.conSubscr || result.details.conSubscr;
        model.hideCaret = true;
        model.showButtons = true;
        model.msgList = this.Controller.Push.prepareHistoryMessageList(subscriptionDetails);
        model.showNotifications = true; // trigger to open the notifications-panel

        // Render connection alarm header with actionbar & segmented control into #Push_Result
        var target = (viewCtx === "Push") ? "Push_Result" : "TP_ResultDetail";
        Hafas.Modules.Render.render({
          file: 'push.index.html',
          target: target,
          template: 'Push_TplConnectionSubscriptionHeader',
          model: model
        });

        // Create and initiate segmented control (if not available yet), push content into panel
        if (typeof this.Controller.Push.segConPush !== 'undefined' &&
            this.Controller.Push.segConPush !== null &&
            typeof this.Controller.Push.segConPush.getState === 'function') {
          // do nothing; segmented control was already initiated
        } else {
          this.Controller.Push.segConPush = Hafas.Core.newType('HafasSegmentedControl', { holder: 'HFS_ConnectionSubscrToggle' });
          this.Controller.Push.segConPush.initiate();
        }
        Hafas("#HFS_ConnectionAlarm_Notifications").innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplIndex_SubscriptionHistory", model);

        Hafas.ps.pub('/GUI/form/hide', [{appcontext: "Push"}]);
        if (viewCtx === "Push") {
          Hafas.ps.pub('/GUI/results/overview/show', [{}]);
        }
        Hafas.ps.pub('/app/events/resize');

        // Focus back button
        Hafas.Util.gui.focusFirstElement('#HFS_DocumentResultOverview');
      }, this));
    }

    if (Hafas.Modules.History && viewCtx === "Push") {
      Hafas.Modules.History.updateData(viewCtx, "subscriptionHistory", data);
    }
  },
  closeInfoPopup: function(){
    if(this.Controller.Push.infoPopup != null){
       this.Controller.Push.infoPopup.close(this.Controller.Push.infoPopup);
    }
  },
  showInfoPopup: function(params){
    var model = {
      subscrData: params.subscrData,
      content: params.content,
      type: params.type,
      onclickConfirm: params.onclickConfirm,
      okButtonClick: params.okButtonClick,
      confirmTitle: params.confirmTitle
    };
    if(typeof params.labelLong != 'undefined'){
      model.labelLong = params.labelLong;
    }
    Hafas.Modules.Render.render(
        {
          template: 'Push_InfoPopup',
          model: model
        },
        Hafas.bind(function (html) {
          this.Controller.Push.infoPopup = Hafas.Core.newType("HafasOverlay", {
            app: this,
            outputHTML: html,
            title: params.title,
            cssClass: 'lyr_pushPopup',
            onClose: function () {
              if (Hafas.Modules.History)
                Hafas.Modules.History.removeCurrentStep("ExportPopup");
              Hafas.Util.gui.restoreFocus('#HFS_PushMoreOptionsBtn');
            }
          });
        },this));
  },
  showDetails: function(data){
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    if (Hafas.Modules.History) {
      Hafas.Modules.History.updateData("Push", "index", {subscrId: data.subscrId, focusSelector: focusSelector});
    }

    Hafas.ps.pub('/tp/searchReconstruction', [data.ctxRecon, "ctxRecon", {showDetails: true}]);
    // We're switching the context here, and pass extra parameters to the "index" Method in order to deactivate an additional history entry
    Hafas.ps.pub('/app/switchContext', [{context: 'TP', method: 'index', params: {addToHistory: false} }]);
    Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TP'}]);
  },
  showAlternatives: function (data) {
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    if (Hafas.Modules.History) {
      Hafas.Modules.History.updateData("Push", "index", {subscrId: data.subscrId, focusSelector: focusSelector});
    }

    // Hier muss ein bisschen getrickst werden, um Start/Ziel zu füllen
    Hafas.ps.pub('/app/switchContext', [{context: 'TP', method: 'index'}]);
    var fillAttempts = 0;
    var fillFormValues = Hafas.bind(function (tmpData) {
      return function () {
        if (Hafas('#From', false) != null) {
          this.Controller.TP.instance.setViaList([]);
          Hafas('#From', false).value = tmpData.start;
          this.Controller.TP.inpFrom.setNoValidLocation();
          Hafas('#To', false).value = tmpData.dest;
          this.Controller.TP.inpTo.setNoValidLocation();
          Hafas.bind(this.Controller.TP.postForm, this)({form: Hafas('#HFS_FormTripSearch')});
        } else {
          if (fillAttempts < 10) {
            window.setTimeout(function () {
              fillFormValues(tmpData);
              fillAttempts++
            }, 100);
          }else{

          }
        }
      }
    }(data), this);
    this.Controller.TP.instance.setTimeNow(false);
    this.Controller.TP.instance.setOutTime(data.depTime);
    this.Controller.TP.instance.setOutDate(data.depDate);
    fillFormValues();
  },
  createDefaultSubscription: function () {
    this.Controller.Push.currentSubscription = {
      settings: Hafas.Core.clone(Hafas.Config.Push.settings),
      channels: Hafas.Core.clone(Hafas.Config.Push.channels),
      repeat: null
    };
  },
  selectChannel: function (data) {
    var channelCheckboxes = Hafas('.lyr_pushChannelCheckboxLabel', true);
    var channelSelected = false;
    var currSubscription = this.Controller.Push.currentSubscription;
    var pushErrorWrapperChannels = Hafas('#HFS_PushErrorWrapperChannels', false);
    for (var i = 0; i < channelCheckboxes.length; i++) {
      Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type:'element', element: channelCheckboxes[i], className: 'js_highLightingErrorBorder'} ]);
      if (pushErrorWrapperChannels !== null) {
        pushErrorWrapperChannels.innerHTML = "";
      }
    }

    // Set checked in currentSubscription
    if (currSubscription !== undefined && currSubscription !== null) {
      currSubscription.channels[data.id].checked = data.checked;

      // Check if we have one active channel
      for (var channelId in currSubscription.channels) {
        var channel = currSubscription.channels[channelId];
        if (channel.checked === true) {
          channelSelected = true;
        }
      }
    }

    // Set checked in input (needed if this method is called to uncheck e.g. webpush after denying permissions
    var channelInput = Hafas('#HFS_PUSH_CHANNEL_CHECKBOX_' + data.id.toUpperCase(), false);
    if (channelInput !== null) {
      channelInput.checked = data.checked;
    }

    // Ask for webpush permission if webpush was checked
    if (data.id === "webpush" && data.checked === true) {
      Hafas.bind(Hafas.Util.worker.handlePushPermission, this)();
    }
  },
  /**
   * Sets the webpush address in the channels config and current subscription
   * @method setWebpushAddress
   */
  setWebpushAddress: function () {
    // Put the webpush configs as address into the channel to prevent missing address after view is rendered again, e.g. after weekday selection
    if (Hafas.Util.checkPath(Hafas.Config, 'Push.channels.webpush') === true && Hafas.Config.Push.channels.webpush.use === true) {
      var address = Hafas.Util.worker.createWebpushAddress();
      if (address !== null) {
        Hafas.Config.Push.channels["webpush"].address = address;

        if (this.Controller.Push.currentSubscription !== null && this.Controller.Push.currentSubscription.channels["webpush"]) {
          this.Controller.Push.currentSubscription.channels["webpush"].address = address;
        }
      }
    }
  },
  validateChannelInput: function (data) {
    var currSub = this.Controller.Push.currentSubscription;
    var subscriptionIdPart = "";

    if (data.subscrId !== undefined && data.subscrId !== "") {
      subscriptionIdPart = '_' + data.subscrId;
    }

    var channelInputField = Hafas('#HFS_PUSHCHANNELINPUT_' + data.id.toUpperCase() + '_' + Hafas.getWebAppContext() + subscriptionIdPart);
    if (channelInputField || data.id === "webpush") {
      // There is no input for webpush
      var valid = false;
      switch (data.id) {
        case "email":
          valid = Hafas.Util.validateEmail(channelInputField.value);
          break;
        case "webpush":
          // If Webpush is selectable and shown, it is valid
          valid = true;
          break;
        case "sms":
          valid = true;
          break; // TODO Sinnvoller Mobilfunknummercheck
      }
      // Wenn Eingabe gültig, dem aktuellen Subscription Objekt hinzufügen
      if (valid) {
        // VALID, add address to channel
        if (data.id === "webpush") {
          // Special webpush address
          var address = Hafas.Util.worker.createWebpushAddress();
          if (address !== null) {
            currSub.channels[data.id].address = address;
          }
        } else {
          // Simple input as address, like email or phone number
          currSub.channels[data.id].address = channelInputField.value;
          // Remove error from input field if it was valid
          Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type:'element', element: channelInputField, className: 'js_highLightingErrorBorder'} ]);
        }
      } else {
        // INVALID, remove address from channel
        delete currSub.channels[data.id].address;
      }
    }
  },
  changeNotificationOption: function (selectedOption) {
    var currSub = this.Controller.Push.currentSubscription;
    currSub.settings.notificationStart = parseInt(selectedOption.value);
  },
  changeDelayOption: function (selectedOption) {
    var currSub = this.Controller.Push.currentSubscription;
    currSub.settings.minDeviationFollowing = parseInt(selectedOption.value);
    currSub.settings.minDeviationInterval = parseInt(selectedOption.value);
  },
  showEditDialog: function (data) {
    // return if no subscription id is set > new alarm needs to be set up first
    if (data.subscrId === undefined) {
      return;
    }
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();
    var me = this;
    var viewCtx = 'Push';
    if (data.origin == 'TP') {
      viewCtx = 'TP';
    }

    var user = this.Controller.Push.getCurrentAlarmCenterUser();
    if (user !== null) {
      var _targetTemplate = 'Push_Result';
      if (viewCtx == 'TP') {
        _targetTemplate = 'TP_ResultDetail';
      }
      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/show', [{}]);

      // Subscription Details laden, um Edit Dialog
      Hafas.Modules.Pushservice.getSubscriptionDetails({
        userId: user.userId,
        subscriptionIds: [data.subscrId]
      }, Hafas.bind(function(dataSubscription){
          Hafas.bind(this.Controller.Push.preProcessSubscription,this)(dataSubscription,data.subscrId,viewCtx);
          var skipPermissionRequest = true;
          Hafas.bind(Hafas.Util.worker.handlePushPermission, this)(skipPermissionRequest);
            Hafas.bind(this.Controller.Push.renderEditDialog,this)();
         },this),
          function(err){
      });

      Hafas.ps.pub('/GUI/form/hide', [{appcontext: viewCtx}]);
      // Im Push Kontext muss die Overview angezeigt werden
      if (viewCtx == 'Push') {
        Hafas.ps.pub('/GUI/results/overview/show', [{}]);
      }
      Hafas.ps.pub('/app/events/resize');
    }
  },
  preProcessSubscription: function (data, subscrId, viewCtx) {
    var result = null;
    var pushCfg = Hafas.Config.Push;
    // Prüfen auf gültiges Subscription Ergebnis
    if (data.svcResL.length > 0 && data.svcResL[0].res.result.resultCode !== 'ERROR') {
      result = data.svcResL[0].res;
    }else{
      return;
    }


    // Subscription Objekt aufbauen
    this.Controller.Push.currentSubscription = {
      settings: Hafas.Core.clone(pushCfg.settings),
      channels: Hafas.Core.clone(pushCfg.channels),
      availableChannels: []
    };

    if(result != null) {
      subscrId = result.subscrId || result.details.subscrId;
      var subscrStatus = result.status || result.details.status;
      var activeSubscrChannels = result.channels || result.details.channels;
      this.Controller.Push.currentSubscription.activeSubscrChannels = Hafas.Core.clone(activeSubscrChannels);

      this.Controller.Push.currentSubscription.subscrId = subscrId;
      this.Controller.Push.currentSubscription.status = subscrStatus;
    }

    // Fill subscription object with data from the server
    // Iterate through existing abo channels and add array for available channels
    for (var channelId in this.Controller.Push.currentSubscription.channels) {
      var currentSubscriptionChannel = this.Controller.Push.currentSubscription.channels[channelId];
      if (currentSubscriptionChannel.use === true) {
        var newAvailableChannel = {
          type: channelId,
          id: channelId
        };
        if(result != null && activeSubscrChannels !== undefined){
          for(var i = 0; i < activeSubscrChannels.length;i++){
            if(activeSubscrChannels[i].type.toLowerCase() === channelId){

              // currentSubscriptionChannel is from the current subscription the user is looking on
              if (channelId === "webpush") {
                // If it's webpush, we have to check if the endpoints match
                var pushData;
                try {
                  // We have to use try/catch as we cannot detect if the address is a direct token or a JSON string while iterating the channels
                  // VAPID
                  pushData = JSON.parse(activeSubscrChannels[i].address);
                } catch (e) {
                  // APNS tokens are used directly
                  pushData = {endpoint: activeSubscrChannels[i].address};
                }

                if (Hafas.Config.Push.clientEndpoint === pushData.endpoint) {
                  newAvailableChannel.address = activeSubscrChannels[i].address;
                  newAvailableChannel.channelId = activeSubscrChannels[i].channelId;
                  newAvailableChannel.checked = activeSubscrChannels[i].active;
                  currentSubscriptionChannel.checked = activeSubscrChannels[i].active;
                  currentSubscriptionChannel.address = activeSubscrChannels[i].address;
                  currentSubscriptionChannel.channelId = activeSubscrChannels[i].channelId;
                }
              } else {
                // Not webpush -> save checked regardless
                newAvailableChannel.address = activeSubscrChannels[i].address;
                newAvailableChannel.channelId = activeSubscrChannels[i].channelId;
                newAvailableChannel.checked = activeSubscrChannels[i].active;
                currentSubscriptionChannel.checked = activeSubscrChannels[i].active;
                currentSubscriptionChannel.address = activeSubscrChannels[i].address;
                currentSubscriptionChannel.channelId = activeSubscrChannels[i].channelId;
              }
            }
          }
        }
        this.Controller.Push.currentSubscription.availableChannels.push(newAvailableChannel);
      }
    }

    var conSubscr = result.conSubscr || result.details.conSubscr;
    this.Controller.Push.currentSubscription.conSubscr = conSubscr;
    if(typeof conSubscr != 'undefined' && typeof conSubscr.hysteresis != 'undefined'){
      for(var h in conSubscr.hysteresis){
        this.Controller.Push.currentSubscription.settings[h] = conSubscr.hysteresis[h];
      }
    }

    /* Get service days from abo */
    if (typeof conSubscr != 'undefined' && typeof conSubscr.serviceDays != 'undefined') {
      this.Controller.Push.currentSubscription.serviceDays = conSubscr.serviceDays;
    }
  },
  initSelectBoxes: function () {
    if (this.Controller.Push.menuSelectBoxes.length > 0) {
      this.Controller.Push.menuSelectBoxes.forEach(function (box) {
        box.destroy();
      });
    }
    this.Controller.Push.menuSelectBoxes = [];
    var notificationSelBox = Hafas.Core.newType('HafasSelectBox', {
      holder: 'HFS_PushNotificationOptions_Holder',
      callback: function (data) {
        Hafas.ps.pub('/push/changeNotificationOption', [data]);
      }
    }).initiate();
    this.Controller.Push.menuSelectBoxes.push(notificationSelBox);

    var delaySelBox = Hafas.Core.newType('HafasSelectBox', {
      holder: 'HFS_PushDelayOptions_Holder',
      callback: function (data) {
        Hafas.ps.pub('/push/changeDelayOption', [data]);
      }
    }).initiate();
    this.Controller.Push.menuSelectBoxes.push(delaySelBox);
  },
  renderEditDialog: function () {
    var pushCfg = Hafas.Config.Push;
    var currentSubscription = this.Controller.Push.currentSubscription;
    var viewCtx = this.appContext;

    var model = {
      subscrId: currentSubscription.subscrId,
      subscrStatus: currentSubscription.status
    };

    if (currentSubscription.conSubscr && currentSubscription.conSubscr.ctxRecon) {
      model.ctxRecon = currentSubscription.conSubscr.ctxRecon;
    }

    if (currentSubscription?.conSubscr?.ctxReconCksumSave) {
      model.ctxReconCksumSave = currentSubscription.conSubscr.ctxReconCksumSave;
    }

    if (typeof currentSubscription.availableChannels != 'undefined') {
      model.availableChannels = currentSubscription.availableChannels;
    }

    /* Repetition */
    var conSubscr = currentSubscription.conSubscr;
    var repeatStatus = 'never';

    model.currentSubscription = conSubscr;

    // Get the repeat status
    if (conSubscr !== undefined && conSubscr.serviceDays !== undefined && conSubscr.serviceDays.selectedWeekdays !== undefined) {
      repeatStatus = 'weekdays';
    }

    // Texte für die ausgewählten Wochentage für die Oberfläche generieren
    if (repeatStatus === 'never') {
      model.repeatStatusText = Hafas.Modules.i18n.get('Push.index.t_N_RepeatNever');
    } else if (repeatStatus === 'weekdays') {
      var repeatData = this.Controller.Push.getRepeatStatusFromSubscription(conSubscr);
      model.repeatStatusText = repeatData.repeatStatusText;
      model.repeatStatusTextLong = repeatData.repeatStatusTextLong;
    }

    // Werte aus bestehendem Abo auslesen
    model.notificationOptions = [];
    for (var n = 0; n < pushCfg.settings.notificationStartOptions.length; n++) {
      var notificationValue = pushCfg.settings.notificationStartOptions[n];
      var selected = (notificationValue === this.Controller.Push.currentSubscription.settings.notificationStart);
      model.notificationOptions.push({
        value: notificationValue,
        label: Hafas.Modules.i18n.get('Push.result.t_N_NotificationsFromXMinutes', {min: notificationValue}),
        selected: selected
      });
    }

    model.delayOptions = [];
    for (var d = 0; d < pushCfg.settings.delayOptions.length; d++) {
      var delayValue = pushCfg.settings.delayOptions[d];
      var selected = (delayValue === this.Controller.Push.currentSubscription.settings.minDeviationInterval);
      model.delayOptions.push({
        value: delayValue,
        label: Hafas.Modules.i18n.get('Push.result.t_N_EditFromXMinutes', {min: delayValue}),
        selected: selected
      });
    }

    // Save render context to prevent rendering an actionbar via channelMailActivationArea / setLoginState
    model.subContext = "settings";

    // Render connection alarm header with actionbar & segmented control
    Hafas.Modules.Render.render({
      file: 'push.index.html',
      target: (viewCtx === 'TP') ? 'TP_ResultDetail' : 'Push_Result',
      template: 'Push_TplConnectionSubscriptionHeader',
      model: model
    });

    // Create and initiate segmented control  (if not available yet)
    if (typeof this.Controller.Push.segConPush !== 'undefined' &&
        this.Controller.Push.segConPush !== null &&
        typeof this.Controller.Push.segConPush.getState === 'function') {
      // do nothing; segmented control was already initiated
    } else {
      this.Controller.Push.segConPush = Hafas.Core.newType('HafasSegmentedControl', { holder: 'HFS_ConnectionSubscrToggle' });
      this.Controller.Push.segConPush.initiate();
    }

    /* Für Edit aus TP wird ein anderer Zweig angesprochen, da die Eingabemaske in einem separaten Container angezeigt wird */
    if (viewCtx === 'TP') {
      if (Hafas.Modules.History) {
        Hafas.Modules.History.addOrUpdateData("TP", "createAlarm", model);
      }

      // New alarm
      // Render connection alarm settings into first segmented control panel (ID: HFS_ConnectionAlarm_Settings)
      Hafas.Modules.Render.render({
        file: 'push.index.html',
        target: 'HFS_ConnectionAlarm_Settings', // Segmented control panel
        template: 'Push_TplEditSubscription',
        model: model
      }, Hafas.bind(function (html) {
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/GUI/results/details/show', [{}]);

        Hafas.bind(this.Controller.Push.initSelectBoxes, this)();

        // Checks if the channel checkboxes have to be disabled
        var skipPermissionRequest = true;
        Hafas.bind(Hafas.Util.worker.handlePushPermission, this)(skipPermissionRequest);

        Hafas.ps.pub('/app/events/resize', []);
      }, this));
      Hafas.ps.pub('/app/events/resize', []);
    } else {

      // Render connection alarm settings into first segmented control panel (ID: HFS_ConnectionAlarm_Settings)
      Hafas("#HFS_ConnectionAlarm_Settings").innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplEditSubscription", model);
      Hafas.bind(this.Controller.Push.initSelectBoxes, this)();

      // Checks if the channel checkboxes have to be disabled
      var skipPermissionRequest = true;
      Hafas.bind(Hafas.Util.worker.handlePushPermission, this)(skipPermissionRequest);
    }
    Hafas.ps.pub('/app/events/resize');

    // Focus back button
    Hafas.Util.gui.focusFirstElement('#HFS_DocumentResultOverview');
  },
  // Toggle the subscription status between active and paused
  updateSubscriptionStatus: function(data) {
    var user = this.Controller.Push.getCurrentAlarmCenterUser();
    if (user !== null && data.subscrId !== undefined) {
      // As we might be called by alarm center, we first have to get the subscription details for the called subscription
      Hafas.Modules.Pushservice.getSubscriptionDetails({
        userId: user.userId, // logged-in alarm center user
        subscriptionIds: [data.subscrId] // subscription id from parameters
      }, Hafas.bind(function(dataSubscription) {
        var subscriptionResultDetails = dataSubscription.svcResL[0].res.details;
        var subscrToggleStatus = Hafas("#" + data.triggerId).checked;
        if (subscrToggleStatus === true) {
          // We may have to reopen the cookie dialog for setting functional cookies
          if (!Hafas.Util.isCookieTypeActive('functional')) {
            Hafas.ps.pub('/GUI/common/showCookieSettingsHint', [['functional']]);
            return;
          }
        }

        // Collect data for updating subscription
        var subscriptionData = {};
        subscriptionData.type = "conSubscr";
        subscriptionData.userId = user.userId;
        subscriptionData.subscrId = subscriptionResultDetails.subscrId;
        subscriptionData.ctxRecon = subscriptionResultDetails.conSubscr.ctxRecon;
        subscriptionData.serviceDays = subscriptionResultDetails.conSubscr.serviceDays;
        // Delete "pause-flag" from data-object to re-activate subscription
        if (subscrToggleStatus === true && subscriptionData.serviceDays.pauseBegin !== undefined) {
          delete subscriptionData.serviceDays.pauseBegin;
        }
        subscriptionData.subscrToggleStatus = subscrToggleStatus;

        // Disable the weekday selection buttons
        var repeatOptions = Hafas('input[data-push-selection="weekdays"]', true);
        repeatOptions.forEach(function (input) {
          input.disabled = subscriptionData.subscrToggleStatus !== true;
        });

        // Update subscription with current status (active/paused, depending on existing "pauseBegin")
        Hafas.Modules.Pushservice['updateSubscription'](subscriptionData, Hafas.bind(function () {
          // Set status text into label
          var subscrStatusTxt = Hafas.Modules.i18n.get('common.label.t_N_Alarm') + ": ";
          if (subscriptionData.subscrToggleStatus === true) {
            subscrStatusTxt += Hafas.Modules.i18n.get('Push.result.t_N_AlarmStatus_active');
          } else {
            subscrStatusTxt += Hafas.Modules.i18n.get('Push.result.t_N_AlarmStatus_paused');
          }
          var triggerObj = Hafas("[for=" + data.triggerId + "]");
          if (triggerObj !== null) {
            triggerObj.textContent = subscrStatusTxt;
          }
          var pauseAllBtn = Hafas('#HFS_PUSH_PAUSE_ALL', false);
          if (subscriptionData.subscrToggleStatus === true) {
            // If is active, show the pause all button on alarm center overview
            if (pauseAllBtn !== null) {
              Hafas.Util.gui.setVisibility(pauseAllBtn, true);
            }
          } else {
            // If deactivated, check if all subscriptions are deactivated. If so, hide the pause all btn
            var allPauseSwitches = Hafas('input[data-pause-subscription]', true);
            var hasActiveAlarms = false;
            allPauseSwitches.forEach(pauseSwitch => {
              if (pauseSwitch.checked === true) {
                hasActiveAlarms = true;
              }
            });
            if (hasActiveAlarms === false && pauseAllBtn !== null) {
              Hafas.Util.gui.setVisibility(pauseAllBtn, false);
            }
          }
        }), this);
      }, this));
    }
  },
  checkSubscriptionAccountData: function(){
    var currSub = this.Controller.Push.currentSubscription;
    var alarmUserData = this.Controller.Push.getAlarmUserData();
    var userDeviation = false;
    if(currSub != null && alarmUserData != null) {
      for(var channelId in currSub.channels){
          if(typeof alarmUserData[channelId.toUpperCase()] != 'undefined'){
            // Current user address is different from the address saved in the backend
            // Email is the important channel to check as it's used for account verification, because the webpush
            // endpoint might different for multiple devices
             if(alarmUserData[channelId.toUpperCase()] !== currSub.channels[channelId].address && channelId === "email") {
                userDeviation = true;
             }
          }
      }
    }
    return userDeviation;
  },
  /**
   * Sets the disabled state of the saveBtn in create alarm view
   * @method setSaveBtnDisabled
   * @param {boolean} bool Value of the disabled state
   */
  setSaveBtnDisabled: function(bool) {
    var saveBtn = Hafas('#HFS_PUSH_SAVE_BTN_' + Hafas.getWebAppContext(), false);
    if (saveBtn) {
      saveBtn.disabled = bool;
    }
  },
  getAlarmUserData: function(){
    var storage = Hafas.Core.newType("hafasStorage");
    var alarmUserData = storage.get('alarmUserData_' + Hafas.Config.Storage.id);
    if(alarmUserData != null){
      return JSON.parse(alarmUserData);
    }else {
      return null;
    }
  },
  /**
   * Checks the active subscribed channels from Controller.Push.currentSubscription and compares against the possible channels;
   * If there are (webpush) channels active which are not in the current set of channels, it adds them to the result array.
   * @method getOtherActiveChannels
   * @returns {*[]} Array of channels which are not in the list of current channels (therefore most likely webpush on other devices)
   */
  getOtherActiveChannels: function() {
    var otherActiveChannels = [];
    // Iterate and add existing subscribed channels for this subscription
    var activeSubscrChannels = this.Controller.Push.currentSubscription.activeSubscrChannels;
    if (activeSubscrChannels !== undefined && activeSubscrChannels.length > 0 && this.Controller.Push.currentSubscription.channels["webpush"] !== undefined) {
      // Check for multiple webpush channels that are not from this device
      for (var i = 0; i < activeSubscrChannels.length; i++) {
        var activeChannel = activeSubscrChannels[i];
        if (activeChannel.type === "WEBPUSH") {
          // Compare already active channel addresses against the configured channel address for this device
          if (this.Controller.Push.currentSubscription.channels["webpush"].address !== activeChannel.address && activeChannel.active === true) {
            if (activeChannel.channelId !== undefined && activeChannel.channelId !== "") {
              otherActiveChannels.push({
                channelId: activeChannel.channelId
              });
            }
          }
        }
      }
    }
    return otherActiveChannels;
  },
  saveSubscription: function (data) {
    data = data || {};

    if(!Hafas.Util.isCookieTypeActive('functional')) {
      Hafas.ps.pub('/GUI/common/showCookieSettingsHint', [['functional']]);
      return;
    }
    var pushErrorWrapperChannels = Hafas('#HFS_PushErrorWrapperChannels', false);
    var pushErrorWrapperMail = Hafas('#HFS_PushErrorWrapperMail', false);
    var saveBtn = Hafas('#HFS_PUSH_SAVE_BTN_' + Hafas.getWebAppContext(), false);
    var currentSubscription = this.Controller.Push.currentSubscription;
    for (var channelId in currentSubscription.channels) {
      if(currentSubscription.channels[channelId].use) {
        Hafas.ps.pub('/push/validateChannelInput', [{id: channelId, subscrId: data.subscrId}]);
      }
    }

    var isDifferentUser = Hafas.bind(this.Controller.Push.checkSubscriptionAccountData,this)();
    if(isDifferentUser){
      Hafas.ps.pub('/push/showInfoPopup', [{
        title: Hafas.Modules.i18n.get('Push.error.t_N_NewUserMail'),
        content: Hafas.Modules.i18n.get('Push.error.t_N_DifferentUser'),
        type: 'confirm',
        confirmTitle: Hafas.Modules.i18n.get('common.label.t_N_OK')
      }]);
      Hafas('#Push_InfoPopupConfirm',false).onclick = Hafas.bind(function(){
        var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
        Hafas.bind(this.Controller.Push.closeInfoPopup,this)();
        this.Controller.Push.deleteUser(alarmCenterUser, Hafas.bind(function () {
          var storage = Hafas.Core.newType("hafasStorage");
          storage.remove('alarmUser_' + Hafas.Config.Storage.id);
          storage.remove('alarmSubscriptions_' + Hafas.Config.Storage.id);
          storage.remove('alarmUserData_' + Hafas.Config.Storage.id);
          Hafas.bind(this.Controller.Push.saveSubscription,this)(data);
        },this));
      },this)
      // Jump out of saving, it will be called by accepting saveSubscription again
      return;
    }

    var errorMsgsMail = [];
    var errorMsgsChannels = [];
    var channelSelectCount = 0;
    var usedChannelCount = 0;
    for (var channelId in currentSubscription.channels) {
      if (currentSubscription.channels[channelId].use) {
        usedChannelCount++;
      }
    }

    for (var channelId in currentSubscription.channels) {
      if (usedChannelCount === 1) {
        // If only one channel is usable, it will be selected automatically
        currentSubscription.channels[channelId].checked = true;
      }
      if (channelId === "email" || (currentSubscription.channels[channelId].checked && currentSubscription.channels[channelId].use)) {
        // If channel is used and checked or if it's email -> we always need a filled in email
        if (currentSubscription.channels[channelId].checked && currentSubscription.channels[channelId].use) {
          // Only count if it's checked
          channelSelectCount++;
        }
        // Validate channel input for email and checked channels
        if ((currentSubscription.channels[channelId].address === undefined || currentSubscription.channels[channelId].address.length === 0) && channelId !== "webpush") {
          errorMsgsMail.push({
            type: 'NO_CHANNEL_ADDRESS',
            label: Hafas.Modules.i18n.get('Push.index.t_N_FillInfo_' + channelId)
          });
          var subscriptionIdPart = "";
          if (data.subscrId !== undefined && data.subscrId !== "") {
            subscriptionIdPart = "_" + data.subscrId;
          }
          var inputElement = Hafas("#HFS_PUSHCHANNELINPUT_" + channelId.toUpperCase() + "_" + Hafas.getWebAppContext() + subscriptionIdPart);
          if (inputElement !== null) {
            Hafas.ps.pub('/GUI/common/highlightingInput',[{type: 'element', element: inputElement, className: 'js_highLightingErrorBorder', keepClass: true }]);
          }
        }
      }
    }
    if (channelSelectCount === 0) {
      // Check other active channels which might allow saving 0 channels on this device
      var otherActiveChannels = Hafas.bind(this.Controller.Push.getOtherActiveChannels, this)();
      var activeChannelSelectedCount = otherActiveChannels.length;
      if (activeChannelSelectedCount === 0) {
        // Only display a warning if there are also no other selected channels from other devices
        errorMsgsChannels.push({
          type: 'NO_CHANNELS_SELECTED',
          label: Hafas.Modules.i18n.get('Push.index.t_N_SelectAChannel')
        });
      }
    }
    if (errorMsgsMail.length === 0 && errorMsgsChannels.length === 0) {
      // Deactivate save button
      if (saveBtn) {
        saveBtn.disabled = true;
      }

      // Check if there is a alarm user already
      var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
      // There is a alarm user in localStorage => get details from HCI
      if (alarmCenterUser !== null) {
        Hafas.Modules.Pushservice.getUserDetails({
            userId: alarmCenterUser.userId
          }, Hafas.bind(function (userData) {
            if(userData.svcResL[0].err === undefined || userData.svcResL[0].err === 'OK') {
              if (userData.svcResL[0].res.result.resultCode === 'ERROR' && userData.svcResL[0].res.result.externalError === 'NO_SUCH_USER') {
                // User doesn't exist, even thou there is a localStorage entry in the current browser (e.g. user deleted via another device)
                // Delete user and run process of saving the subscription again
                this.Controller.Push.deleteUser(alarmCenterUser, Hafas.bind(function () {
                  var storage = Hafas.Core.newType("hafasStorage");
                  storage.remove('alarmUser_' + Hafas.Config.Storage.id);
                  storage.remove('alarmSubscriptions_' + Hafas.Config.Storage.id);
                  storage.remove('alarmUserData_' + Hafas.Config.Storage.id);
                  Hafas.bind(this.Controller.Push.saveSubscription,this)(data);
                  // Set logout state
                  Hafas.ps.pub('/push/setLoginState', [false]);
                },this));
                return;
              }
            }
            // Check if the subscription has to be added or updated
            if (data !== undefined && data.subscrId !== undefined) {
              Hafas.bind(this.Controller.Push.setupAlarm, this)(userData, {update: true});
            } else {
              // Neuen Alarm anlegen
              Hafas.bind(this.Controller.Push.setupAlarm, this)(userData);
            }
          }, this),
          Hafas.bind(function (errorMsg) {
            console.log("An error has occured while creating an alarmcenter user.");
          }, this));
      } else {
        // There is no alarm user in localStorage => create an user
        Hafas.bind(this.Controller.Push.createNewAlarmCenterUser, this)(
          Hafas.bind(function (data) {
            if (data.errorStatus !== 'ERROR' && data.svcResL?.length > 0) {
              // No error in getting a user ID from HCI => call SubscrUserDetails with that ID
              Hafas.Modules.Pushservice.getUserDetails({
                userId: data.svcResL[0].res.userId
              }, Hafas.bind(function(){
                    // Same data with the user ID is processed => setup the alarm
                    Hafas.bind(this.Controller.Push.setupAlarm,this)(data,null,Hafas.bind(function(){
                      // We must not save the user ID until the email channel was confirmed, otherwise it can lead to multiple email channels for one user ID which we can't handle yet
                      // var user = Hafas.bind(this.Controller.Push.storeAlarmCenterUser, this)(data);
                      // Show InfoPopup
                      Hafas.ps.pub('/push/showInfoPopup', [{
                        title: Hafas.Modules.i18n.get('Push.index.t_N_LoginLinkSent'),
                        content: Hafas.Modules.i18n.get('Push.index.t_N_LoginLinkSentExplanation'),
                        type: 'OK'
                      }]);
                    },this));
                 }, this), function (errorMsg) {
                console.log("An error has occured while creating an alarmcenter user.");
              });
            } else {
              errorMsgsMail.push({
                type: 'SERVER_ERROR',
                label: Hafas.Modules.i18n.get('Push.error.t_N_ServerException')
              });
              pushErrorWrapperMail.innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgsMail});

              // Make save button active again
              if (saveBtn) {
                saveBtn.disabled = false;
              }
            }
          }, this),
          function (errCreateUserRequestErr) {

          }
        );
      }
    }

    // Handle errors for channel area
    if (pushErrorWrapperChannels !== null) {
      if (errorMsgsChannels.length > 0) {
        // Error highlighting on checkboxes
        var channelCheckboxes = Hafas('.lyr_pushChannelCheckboxLabel', true);
        for (var i = 0; i < channelCheckboxes.length; i++) {
          Hafas.ps.pub('/GUI/common/highlightingInput',[{type: 'element', element: channelCheckboxes[i], className: 'js_highLightingErrorBorder', keepClass: true }]);
        }
        // Error message
        pushErrorWrapperChannels.innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgsChannels});
      } else {
        pushErrorWrapperChannels.innerHTML = "";
      }
    }

    // Handle errors for mail area
    if (pushErrorWrapperMail !== null) {
      if (errorMsgsMail.length > 0) {
        pushErrorWrapperMail.innerHTML = Hafas.Modules.Render.renderTemplate("Push_TplErrorList", {errorMsgs: errorMsgsMail});
      } else {
        pushErrorWrapperMail.innerHTML = "";
      }
    }
  },
  deleteSubscription: function (data) {
    // Delete Button deaktivieren
    if (Hafas('#push_deleteBtn', false)) {
      Hafas('#push_deleteBtn', false).disabled = true;
    }

    var alarmCenterUser = this.Controller.Push.getCurrentAlarmCenterUser();
    if (typeof data.subscrId != 'undefined') {
      Hafas.Modules.Pushservice.deleteSubscription({
        subscriptionId: data.subscrId,
        userId: alarmCenterUser.userId
      }, Hafas.bind(function (subscrDeleteData) {
        this.Controller.Push.deleteSubscriptionStorage(data.ctxReconCksumSave, data.ctxRecon);
        if (typeof data.ctx == 'undefined' && this.appContext !== 'TP') {
          Hafas.bind(this.Controller.Push.renderIndex, this)();
          Hafas.ps.pub('/GUI/form/show', [{}]);
          Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
          Hafas.ps.pub('/app/events/resize');
        } else {
          // Schritt aus der History löschen
          Hafas.Modules.History.removeCurrentStep("createAlarm");

          // Alarm wurde erfolgreich gelöscht ... Zurück zu den Verbindungsdetails
          Hafas.bind(this.Controller.TP.renderConnectionDetails, this)(this.Controller.TP.selectedConnection, {
            connectionType: this.Controller.TP.activeSelection.connType,
            arrayIdx: this.Controller.TP.activeSelection.arrayIdx
          });
        }
      }, this));
    }
  },
  deleteSubscrConfirmation: function(data) {
    var currentSubscription = this.Controller.Push.currentSubscription;
    var startLocation = "";
    var destLocation = "";
    if (currentSubscription.conSubscr.connectionInfo !== undefined) {
      var conInfo = currentSubscription.conSubscr.connectionInfo;
      startLocation = conInfo[0].departureStationName;
      destLocation = conInfo[conInfo.length - 1].arrivalStationName;
    }
    Hafas.ps.pub('/push/showInfoPopup', [{
      title: Hafas.Modules.i18n.get('Push.index.t_N_DeleteTripAlarm'),
      content: Hafas.Modules.i18n.get('Push.index.t_L_DeleteTripAlarm', {startLoc: startLocation, destLoc: destLocation}),
      type: 'confirm',
      confirmTitle: Hafas.Modules.i18n.get('Push.index.t_N_deleteAccountYes'),
      onCancel: function () {},
      onclickConfirm: "Hafas.ps.pub('/push/closeInfoPopup'); Hafas.ps.pub('/push/delete',[{subscrId: " + data.subscrId + ", ctxRecon: '" + data.ctxRecon + "', ctxReconCksumSave: '" + data.ctxReconCksumSave + "'}]);",
    }]);
  },
  logOutFromMailDialog: function(modelKey) {
    if (modelKey !== undefined) {
      var model = Hafas.Modules.Render.objectKeeper.get(modelKey);
      Hafas.ps.pub('/push/showInfoPopup', [{
        title: Hafas.Modules.i18n.get('Push.index.t_N_LogOutFromMail'),
        content: Hafas.Modules.i18n.get('Push.index.t_N_LogOutFromMailExplanation', {email: model.inputField.value}),
        type: 'confirm',
        confirmTitle: Hafas.Modules.i18n.get('Push.index.t_N_LogOutYes'),
        onCancel: function () {

        },
        onclickConfirm: "Hafas.ps.pub('/push/closeInfoPopup');Hafas.ps.pub('/push/logOutFromMail', ['" + modelKey + "']);"
      }]);
    }
  },
  logOutFromMail: function (modelKey) {
    if (modelKey !== undefined) {
      var model = Hafas.Modules.Render.objectKeeper.get(modelKey);

      this.Controller.Push.removePushUserData();

      if (Hafas.getWebAppContext() === 'Push') {
        // We're in Push: If the user is logged out, show the alarmcenter again
        if (Hafas.Modules.History) {
          Hafas.Modules.History.removeCurrentStep("edit");
        }

        Hafas.bind(this.Controller.Push.renderIndex, this)();

        if (Hafas.Modules.History) {
          Hafas.Modules.History.updateData("Push", "index", {}, {preventClone:true}); // Remove data from history entry which holds a subscrId, which is invalid after logging out
        }
      } else {
        // We're in TP details / alarm view: Just render the channel mail activation element again

        // Delete mail from input and channels
        delete model.subscrId;
        delete model.inputField; // Will be defined in atom again
        if (model.availableChannels !== undefined) {
          for (var i = 0; i < model.availableChannels.length; i++) {
            var currChannel = model.availableChannels[i];
            delete currChannel.address;
            delete currChannel.channelId;
          }
        }

        // Define the alarm as new, e.g. to hide the delete button
        model.type = 'new';
        if (model.subContext === "settings") {
          // Rerender the connection subscription setup page
          Hafas.bind(this.Controller.GUI.Push.showOptions, this)({ // In showOptions we need connectionType and currentIdx as used in /GUI/openPush
            connectionType: this.Controller.TP.selectedConnection.connectionType,
            arrayIdx: this.Controller.TP.selectedConnection.currentIdx
          });
        } else {
          // Render the mail input again
          Hafas.Modules.Render.render({
            file: 'push.index.html',
            target: Hafas('[data-render-element="push_mail_activation"]'),
            template: 'Push_AtomTplChannelMailActivation',
            model: model
          }, Hafas.bind(function (html) {}, this));
        }
      }
    }
  },
  showMoreNotifications: function (data) {
    var singleNotifications = Hafas('#Push_Result .lyr_subscriptionMessage', true);
    for (var i = 0; i < singleNotifications.length; i++) {
      var currentNotification = singleNotifications[i];
      currentNotification.removeAttribute("hidden");
      var moreBtnWrapper = Hafas("#HFS_morePushNotificationsBtnWrapper");
      if (moreBtnWrapper !== null) {
        moreBtnWrapper.hidden = true;
      }
    }
  },
  getRepeatStatusFromSubscription: function (subscription) {
    var data = {};
    if (subscription.serviceDays === undefined || subscription.serviceDays.selectedWeekdays === undefined || subscription.serviceDays.selectedWeekdays === null) {
      data.repeatStatus = 'never';
      data.repeatStatusText = Hafas.Modules.i18n.get('Push.index.t_N_RepeatNever');
      data.repeatStatusTextLong = Hafas.Modules.i18n.get('Push.index.t_N_RepeatNever');
    } else {
      var weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      var wdStatusText = '';
      var wdStatusTextLong = '';
      var selWeekDays = subscription.serviceDays.selectedWeekdays;
      for (var i = 0; i < selWeekDays.length; i++) {
        var currentWD = selWeekDays.charAt(i);
        if (currentWD === "1") {
          if (wdStatusText.length > 0) {
            wdStatusText += ", ";
            wdStatusTextLong += ', ';
          }
          wdStatusText += Hafas.Modules.i18n.get('common.weekdays.t_S_' + weekdays[i]);
          wdStatusTextLong += Hafas.Modules.i18n.get('common.weekdays.t_N_' + weekdays[i]);
        }
      }
      // Prüfen, ob es nicht ausgewählte Wochentage gibt, sonst "täglich" als String setzen
      if (selWeekDays.indexOf("0") === -1) {
        wdStatusText = Hafas.Modules.i18n.get('Push.index.t_N_DailySubscription');
      }
      data.repeatStatus = 'weekdays';
      data.repeatStatusText = wdStatusText;
      data.repeatStatusTextLong = wdStatusTextLong;
    }
    return data;
  },
  updateWeekdaySelection: function () {
    var weekdayString = '';
    Hafas('input[data-push-selection="weekdays"]', true).forEach(function (wdCheckbox) {
      if (wdCheckbox.checked) {
        weekdayString += '1';
      } else {
        weekdayString += '0';
      }
    });
    var currSubscr = this.Controller.Push.currentSubscription;
    if (currSubscr.serviceDays === undefined) {
      currSubscr.serviceDays = {};
    }
    currSubscr.serviceDays.selectedWeekdays = weekdayString;

    if (currSubscr.conSubscr !== undefined) {
      currSubscr.conSubscr.serviceDays.selectedWeekdays = weekdayString;
    }
    if (weekdayString != null && weekdayString.indexOf("1") === -1) {
      if (currSubscr.conSubscr !== undefined) {
        delete currSubscr.conSubscr.serviceDays.selectedWeekdays;
      }
      delete currSubscr.serviceDays.selectedWeekdays;
    }
  },
  /**
   * Toggles the pause status of the alarm center user
   * @param {boolean} boolval True if user should be paused
   */
  pauseAlarms: function (boolval) {
    var user = this.Controller.Push.getCurrentAlarmCenterUser();
    if (user !== null) {
      Hafas.Modules.Pushservice.getUserDetails({
        userId: user.userId
      }, Hafas.bind(function (userDetails) {
        var userResult = userDetails.svcResL[0].res;
        var hfsTimeNow = Hafas.Core.newType("hafasTime", {jsDate: new Date()});
        var hciDateTime = Hafas.Util.date.hfsTimeToISO(hfsTimeNow);
        var pauseOptions = {
          userId: user.userId,
          options: {}
        };
        if (typeof userResult.availableChannels != 'undefined') {
          pauseOptions.options.availableChannels = userResult.availableChannels;
        }
        if (typeof userResult.channels != 'undefined') {
          pauseOptions.options.channels = userResult.channels;
        }
        if (typeof userResult.language != 'undefined') {
          pauseOptions.options.language = userResult.language;
        }
        if (boolval) {
          pauseOptions.options.pauseBegin = hciDateTime;
        }
        Hafas.Modules.Pushservice.updateUser(pauseOptions, function (updateResult) {

        }, function (err) {

        });
      }, this));
    }
  },
  pauseAllSubscriptions: function() {
    var allPauseSwitches = Hafas('input[data-pause-subscription]', true);
    var pauseAllBtn = Hafas('#HFS_PUSH_PAUSE_ALL', false);

    allPauseSwitches.forEach(pauseSwitch => {
      if (pauseSwitch.checked === true) {
        pauseSwitch.checked = false;
        pauseSwitch.onclick();
      }
    });
    if (pauseAllBtn !== null) {
      Hafas.Util.gui.setVisibility(pauseAllBtn, false);
    }
  },
  closeView: function (histData) {
    // console.log("+++ close view +++", histData);
    switch (histData.view) {
      case "subscriptionHistory":
      case "edit":
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        break;
    }
  },
  restoreView: function (histData) {
    // console.log("+++ restore view +++", histData);
    var view = histData.view;
    switch (view) {
      case "index":
        if (histData.data.focusSelector) {
          this.Controller.Push.focusSelector = histData.data;
        }
        Hafas.ps.pub('/GUI/form/show', [{}]);
        Hafas.bind(this.Controller.Push.renderIndex, this)(histData.data);
        break;
      case "edit":
        Hafas.bind(this.Controller.Push.showEditDialog, this)(histData.data);
        break;
      case "subscriptionHistory":
        Hafas.bind(this.Controller.Push.showMessages, this)(histData.data);
        break;
    }
  },
  cleanup: function () {
    if (this.Controller.Push.segConPush !== undefined) {
      this.Controller.Push.segConPush.destroy();
      delete this.Controller.Push.segConPush;
    }

    Hafas("#Push_Result").innerHTML = "";
    this.Controller.Push.currentSubscription = null;
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    Hafas.ps.pub('/GUI/form/hide', [{}]);
  }
}
